import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Header } from 'semantic-ui-react';
import i18next from 'i18next';
import { Redirect } from 'react-router';
import Companies from './Companies';

const BudgetsHome = (props) => {
    const companies = useSelector(state => state.budgetsApp.companies);

    if (companies.length === 1) {
        return <Redirect to={{ pathname: `/company/${companies[0].id}` }} />;
    }

    return (
        <div>
            <Header size="large" icon='building' content={i18next.t('companies')} style={{ margin: 10 }} />

            <Companies {...props} />
        </div>
    );
};

BudgetsHome.propTypes = {
    
};

export default BudgetsHome;